import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axios';

export const createCenters = createAsyncThunk(
    'centers/create',
    async (credentials, thunkAPI) => {
        try {
          const response = await axiosInstance.post('/centers', {
            ...credentials
          });
          return response.data;
        } catch (error) {
          return thunkAPI.rejectWithValue(error.response?.data?.message || 'Center creation failed');
        }
      }
  );
export const editCenters = createAsyncThunk('centers/edit', async (credentials, thunkAPI) => {
    try {
        const response = await axiosInstance.put(`/centers/${credentials.id}`, {
            ...credentials
        });
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data?.message || 'Center update failed');
    }
});

export const getAllCenters = createAsyncThunk(
    'centers/getAll',
    async (_, thunkAPI) => {
        try {
          const response = await axiosInstance.get('/centers');
          return response.data;
        } catch (error) {
          return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch centers');
        }
      }
  );
  export const getActiveCenter = createAsyncThunk(
    'centers/getActive',
    async (_, thunkAPI) => {
        try {
          const response = await axiosInstance.get('/centers/get/active');
          return response.data;
        } catch (error) {
          return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch active centers');
        }
      }
  );

const centerSlice = createSlice({
  name: "centers",
  initialState: {
      centers: [],
      loading: false,
      error: null
    },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create centers
      .addCase(createCenters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCenters.fulfilled, (state, action) => {
        state.loading = false;
        // If we want to update the centers array with the newly created center
        if (action.payload?.data) {
          state.centers.push(action.payload.data);
        }
      })
      .addCase(createCenters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      // Get all centers
      .addCase(getAllCenters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCenters.fulfilled, (state, action) => {
        state.loading = false;
        state.centers = action.payload.message || [];
      })
      .addCase(getAllCenters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // Edit centers
      .addCase(editCenters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editCenters.fulfilled, (state, action) => {
        state.loading = false;
        // If we want to update the centers array with the edited center
        const index = state.centers.findIndex(center => center.id === action.payload.id);
        if (index !== -1) {
          state.centers[index] = action.payload;
        }
      })
      .addCase(editCenters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      // Get active centers
      .addCase(getActiveCenter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActiveCenter.fulfilled, (state, action) => {
        state.loading = false;
        state.centers = action.payload.message || [];
      })
      .addCase(getActiveCenter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  }
});

export default centerSlice.reducer;